export class AzureSqlTdeRestoreConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "keyVaultKeyUri",
            "baseName": "keyVaultKeyUri",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureSqlTdeRestoreConfig.attributeTypeMap;
    }
    constructor() {
    }
}
